import {ENDPOINT_URL} from '../constants/index';
import {apiErrorHandling} from '../utils/apiUtils';

import getFetchOptions from '../utils/getFetchOptions';

export default function addClassesToGroup(classData) {
	return fetch(
		`${ENDPOINT_URL}/addclasstogroups`,
		getFetchOptions({
			method: 'POST',
			body: JSON.stringify({
				classData,
			}),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
